module.exports = __webpack_public_path__ + "static/Sam-9574549e8a942c6fc526767a19d9c154.jpg";